import { WorksheetAssociatedTestSection } from 'Components/Worksheets/Core';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { Guid } from 'Lib/Guid';
import React from 'react';
import { useSelector } from 'react-redux';
import { Field, NumericInput, RadioGroup, TextOutput } from '../../../../../Core';
import { withInjectedProps } from '../../../../../Core/InjectedPropsContext';
import { ListFieldSection } from '../../../../../Layout';
import { default as externalTestMethods } from '../../../../ExternalTestMethods';
import AsFieldMddSection from './FieldMddSection';

let AsFieldResultsSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const importedFieldMoistureContentID = useSelector(
    createWorksheetSelector!('AssociatedLabMoistureContent.ImportedTest.Id')
  ) as Guid;
  const importedFieldWetDensityID = useSelector(
    createWorksheetSelector!('AssociatedFieldWetDensity.ImportedTest.Id')
  ) as Guid;
  const labMoistureTaken = useSelector(createWorksheetSelector!('LabMoistureTaken')) as boolean;
  const FieldWetDensityMethod = useSelector(createWorksheetSelector!('AssociatedFieldWetDensity.ExternalTest.Method'));
  return (
    <>
      <ListFieldSection>
        <Field
          input={<RadioGroup />}
          name="LabMoistureTaken"
          options={[
            { label: 'Yes', value: true },
            { label: 'No', value: false },
          ]}
        ></Field>
      </ListFieldSection>
      <WorksheetAssociatedTestSection
        heading="Field Wet Density"
        name="AssociatedFieldWetDensity"
        testType="Nuclear Field Density"
        associatedTestModel={{
          autoImported: true,
          imported: {
            importedTestResults: (
              <ListFieldSection>
                <Field input={<TextOutput />} name="FieldWetDensity" />
                <Field input={<TextOutput />} name="FieldMoistureContent" />
              </ListFieldSection>
            ),
            importModel: {
              Id: importedFieldWetDensityID,
            },
          },
          external: {
            testMethods: [
              externalTestMethods.nuclearFieldDensity.AS_1289_5_8_1,
              externalTestMethods.sandConeFieldDensity.AS1289_5_3_1,
            ],
            permitOtherTestMethods: false,
            externalTestResults: (
              <ListFieldSection>
                <Field input={<NumericInput />} name="AssociatedFieldWetDensity.ExternalTest.Results.FieldWetDensity" />
                <Field
                  input={<NumericInput />}
                  name="AssociatedFieldWetDensity.ExternalTest.Results.FieldMoistureContent"
                  visible={FieldWetDensityMethod === externalTestMethods.nuclearFieldDensity.AS_1289_5_8_1.value}
                />
              </ListFieldSection>
            ),
          },
        }}
      />

      <AsFieldMddSection />
      {labMoistureTaken && (
        <WorksheetAssociatedTestSection
          heading="Moisture Content Excluding Oversize"
          name="AssociatedLabMoistureContent"
          testType="Moisture Content"
          associatedTestModel={{
            autoImported: true,
            imported: {
              importedTestResults: (
                <ListFieldSection>
                  <Field input={<TextOutput />} name="LabMoistureContent" />
                </ListFieldSection>
              ),
              importModel: {
                Id: importedFieldMoistureContentID,
              },
            },
            external: {
              testMethods: [externalTestMethods.moistureContent.AS_1289_2_1_1],
              permitOtherTestMethods: false,
              externalTestResults: (
                <ListFieldSection>
                  <Field
                    input={<NumericInput />}
                    name="AssociatedLabMoistureContent.ExternalTest.Results.MoistureContentPercent"
                  />
                </ListFieldSection>
              ),
            },
          }}
        />
      )}
    </>
  );
};

AsFieldResultsSection = withInjectedProps(AsFieldResultsSection);

export { AsFieldResultsSection };
export default AsFieldResultsSection;
